import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { taskService } from "../services/task.service";

export const createTask = createAsyncThunk("createTask", async (data, { rejectWithValue }) => {
    try {
        return await taskService.createTask(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const createMultipleTasks = createAsyncThunk("createMultipleTasks", async ({data}, { rejectWithValue }) => {
    try {
        return await taskService.createMultipleTasks(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getTaskList = createAsyncThunk("getTaskList", async (params, { rejectWithValue }) => {
    try {
        return await taskService.getTaskList(params);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getTask = createAsyncThunk("getTask", async (id, { rejectWithValue }) => {
    try {
        return await taskService.getTask(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updateTask = createAsyncThunk("updateTask", async ({data,id}, { rejectWithValue }) => {
    try {
        return await taskService.updateTask(id, data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updateMultipleTask = createAsyncThunk("updateMultipleTask", async (data, { rejectWithValue }) => {
    try {
        return await taskService.updateMultipleTask(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const deleteTask = createAsyncThunk("deleteTask", async (id, { rejectWithValue }) => {
    try {
        return await taskService.deleteTask(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getTasksByUser = createAsyncThunk("getTasksByUser", async (params, { rejectWithValue }) => {
    try {
        //if status =="", then remove it
        if(params.status === ""){
            delete params.status;
        }
        return await taskService.getTasksByUser(params);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});


export const addTaskTimeLog = createAsyncThunk("addTaskTimeLog", async (data, { rejectWithValue }) => {
    try {
        return await taskService.addTaskTimeLog(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const changeTaskTimeLog = createAsyncThunk("changeTaskTimeLog", async (data, { rejectWithValue }) => {
    try {
        return await taskService.changeTaskTimeLog(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});


export const myTimeLog = createAsyncThunk("myTimeLog", async (_,{ rejectWithValue }) => {
    try {
        return await taskService.myTimeLog();
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});


const taskSlice = createSlice({
    name: "pmo-task",
    initialState: {
        list: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        detail: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        create: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        createMultiple: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        updateMultiple: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        update: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        delete: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        userTasks: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        timeLog: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        changeTimeLog: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        myTimeLog: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        }   
    },
    reducers: {
        resetStateTask: (state) => {
            state.list.isError = false;
            state.list.message = null;
            state.detail.isError = false;
            state.detail.message = null;
            state.create.isError = false;
            state.create.message = null;
            state.create.data = null;
            state.createMultiple.isError = false;
            state.createMultiple.message = null;
            state.createMultiple.data = null;
            state.updateMultiple.isError = false;
            state.updateMultiple.message = null;
            state.updateMultiple.data = null;
            state.update.isError = false;
            state.update.message = null;
            state.update.data = null;
            state.delete.isError = false;
            state.delete.message = null;
            state.delete.data = null;
            state.userTasks.isError = false;
            state.userTasks.message = null;
            state.timeLog.isError = false;
            state.timeLog.message = null;
            state.timeLog.data = null;
            state.changeTimeLog.isError = false;
            state.changeTimeLog.message = null;
        },
        resetTimeLog: (state) => {
            state.timeLog.data = null;
        },
    },
    extraReducers: (builder) => {
        // get task list
        builder.addCase(getTaskList.pending, (state) => {
            state.list.isLoading = true;
            state.list.data = null;
        });
        builder.addCase(getTaskList.fulfilled, (state, action) => {
            state.list.isLoading = false;
            state.list.data = action.payload;
            state.list.isError = false;
        });
        builder.addCase(getTaskList.rejected, (state, action) => {
            state.list.isLoading = false;
            state.list.isError = true;
            state.list.message = action.payload?.message;
        });

        // get task detail
        builder.addCase(getTask.pending, (state) => {
            state.detail.isLoading = true;
        });
        builder.addCase(getTask.fulfilled, (state, action) => {
            state.detail.isLoading = false;
            state.detail.data = action.payload;
            state.detail.isError = false;
        });
        builder.addCase(getTask.rejected, (state, action) => {
            state.detail.isLoading = false;
            state.detail.isError = true;
            state.detail.message = action.payload?.message;
        });

        // create task
        builder.addCase(createTask.pending, (state) => {
            state.create.isLoading = true;
        });
        builder.addCase(createTask.fulfilled, (state, action) => {
            state.create.isLoading = false;
            state.create.data = action.payload;
            state.create.isError = false;
        });
        builder.addCase(createTask.rejected, (state, action) => {
            state.create.isLoading = false;
            state.create.isError = true;
            state.create.message = action.payload?.message;
        });

        // create multiple tasks
        builder.addCase(createMultipleTasks.pending, (state) => {
            state.createMultiple.isLoading = true;
        });
        builder.addCase(createMultipleTasks.fulfilled, (state, action) => {
            state.createMultiple.isLoading = false;
            state.createMultiple.data = action.payload;
            state.createMultiple.isError = false;
        });
        builder.addCase(createMultipleTasks.rejected, (state, action) => {
            state.createMultiple.isLoading = false;
            state.createMultiple.isError = true;
            state.createMultiple.message = action.payload?.message;
        });

        // update task
        builder.addCase(updateTask.pending, (state) => {
            state.update.isLoading = true;
        });
        builder.addCase(updateTask.fulfilled, (state, action) => {
            state.update.isLoading = false;
            state.update.data = action.payload;
            state.update.isError = false;
        });
        builder.addCase(updateTask.rejected, (state, action) => {
            state.update.isLoading = false;
            state.update.isError = true;
            state.update.message = action.payload?.message;
        });

        // delete task
        builder.addCase(deleteTask.pending, (state) => {
            state.delete.isLoading = true;
        });
        builder.addCase(deleteTask.fulfilled, (state, action) => {
            state.delete.isLoading = false;
            state.delete.data = action.payload;
            state.delete.isError = false;
        });
        builder.addCase(deleteTask.rejected, (state, action) => {
            state.delete.isLoading = false;
            state.delete.isError = true;
            state.delete.message = action.payload?.message;
        });



        // get tasks by user
        builder.addCase(getTasksByUser.pending, (state) => {
            state.userTasks.isLoading = true;
        });
        builder.addCase(getTasksByUser.fulfilled, (state, action) => {
            state.userTasks.isLoading = false;
            state.userTasks.data = action.payload;
            state.userTasks.isError = false;
        });
        builder.addCase(getTasksByUser.rejected, (state, action) => {
            state.userTasks.isLoading = false;
            state.userTasks.isError = true;
            state.userTasks.message = action.payload?.message;
        });


        // add task time log
        builder.addCase(addTaskTimeLog.pending, (state) => {
            state.timeLog.isLoading = true;
        });
        builder.addCase(addTaskTimeLog.fulfilled, (state, action) => {
            state.timeLog.isLoading = false;
            state.timeLog.data = action.payload;
            state.timeLog.isError = false;
        });
        builder.addCase(addTaskTimeLog.rejected, (state, action) => {
            state.timeLog.isLoading = false;
            state.timeLog.isError = true;
            state.timeLog.message = action.payload?.message;
        });

        // change task time log
        builder.addCase(changeTaskTimeLog.pending, (state) => {
            state.changeTimeLog.isLoading = true;
        });
        builder.addCase(changeTaskTimeLog.fulfilled, (state, action) => {
            state.changeTimeLog.isLoading = false;
            state.changeTimeLog.data = action.payload;
            state.changeTimeLog.isError = false;
        });
        builder.addCase(changeTaskTimeLog.rejected, (state, action) => {
            state.changeTimeLog.isLoading = false;
            state.changeTimeLog.isError = true;
            state.changeTimeLog.message = action.payload?.message;
        });

        // update multiple task
        builder.addCase(updateMultipleTask.pending, (state) => {
            state.updateMultiple.isLoading = true;
        });
        builder.addCase(updateMultipleTask.fulfilled, (state, action) => {
            state.updateMultiple.isLoading = false;
            state.updateMultiple.data = action.payload;
            state.updateMultiple.isError = false;
        });
        builder.addCase(updateMultipleTask.rejected, (state, action) => {
            state.updateMultiple.isLoading = false;
            state.updateMultiple.isError = true;
            state.updateMultiple.message = action.payload?.message;
        });
        // my time log
        builder.addCase(myTimeLog.pending, (state) => {
            state.myTimeLog.isLoading = true;
            state.myTimeLog.data = null;
        });
        builder.addCase(myTimeLog.fulfilled, (state, action) => {
            state.myTimeLog.isLoading = false;
            state.myTimeLog.data = action.payload;
            state.myTimeLog.isError = false;
        });
        builder.addCase(myTimeLog.rejected, (state, action) => {
            state.myTimeLog.isLoading = false;
            state.myTimeLog.isError = true;
            state.myTimeLog.message = action.payload?.message;
            state.myTimeLog.data = null;
        });
    },
});

export default taskSlice.reducer;
export const { resetStateTask, resetTimeLog } = taskSlice.actions;